import React from 'react';
import { Navigate } from 'react-router-dom';
import PolicyPage from './index';
import {
  PolicyDocument,
  brandHasPolicy,
  brandPolicyPath,
  brandPolicyTitle,
  getBrand,
} from '../../constants/brands';
import { policyKindFromSlug } from '../../services/policyService/policyKinds';

/** One policy document of this page's brand; a document the brand does not publish goes to the terms. */
const BrandPolicyPage: React.FC<{ doc: PolicyDocument }> = ({ doc }) => {
  const brand = getBrand();
  if (!brandHasPolicy(doc, brand)) return <Navigate to="/policies/terms" replace />;
  const kind = policyKindFromSlug(doc) ?? 'TERMS';
  return (
    <PolicyPage
      title={brandPolicyTitle(doc, brand)}
      contentPath={brandPolicyPath(doc, brand)}
      kind={kind}
    />
  );
};

export default BrandPolicyPage;
